import { infiniteQueryOptions } from "@tanstack/react-query"
import { getRelationRobot } from "../room"

// 相关机器人
export const RelationRobotQueryOption = infiniteQueryOptions({
  queryKey: ['user', 'relation', 'robot'],
  initialPageParam: { page: 1, page_size: 20 },
  queryFn: async ({ pageParam, }): Promise<any> => (await getRelationRobot(pageParam)).data,
  getNextPageParam(lastPage: any[], allPages, lastPageParam): any {
    if (!lastPage?.length) return null
    return { ...lastPageParam, page: lastPageParam.page + 1 }
  },
})